/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiaglabSampleItemStatus from './diaglab-sample-item-status';
import DiaglabSampleItemStatusDetail from './diaglab-sample-item-status-detail';
import DiaglabSampleItemStatusUpdate from './diaglab-sample-item-status-update';
import DiaglabSampleItemStatusDeleteDialog from './diaglab-sample-item-status-delete-dialog';

const DiaglabSampleItemStatusRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiaglabSampleItemStatus />} />
    <Route path="new" element={<DiaglabSampleItemStatusUpdate />} />
    <Route path=":id">
      <Route index element={<DiaglabSampleItemStatusDetail />} />
      <Route path="edit" element={<DiaglabSampleItemStatusUpdate />} />
      <Route path="delete" element={<DiaglabSampleItemStatusDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiaglabSampleItemStatusRoutes;
